import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../axios";

// Какие поля показывать в форме заявки. Настраивается в админке
// (раздел «Форма заявки»), здесь же лежат значения по умолчанию —
// если бэкенд недоступен, форма показывается в полном виде.
export const DEFAULT_REQUEST_FORM = {
    phone: true,
    email: true,
    people: true,
    subject: true,
    comment: false,
};

export const fetchRequestForm = createAsyncThunk(
    "requestForm/fetch",
    async () => {
        const { data } = await axios.get("/settings/request-form");
        return data;
    }
);

export const saveRequestForm = createAsyncThunk(
    "requestForm/save",
    async (settings) => {
        const { data } = await axios.put("/settings/request-form", settings);
        return data;
    }
);

const initialState = {
    settings: DEFAULT_REQUEST_FORM,
    status: "idle", // idle | loading | loaded | error
};

const requestFormSlice = createSlice({
    name: "requestForm",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchRequestForm.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchRequestForm.fulfilled, (state, action) => {
                state.settings = { ...DEFAULT_REQUEST_FORM, ...action.payload };
                state.status = "loaded";
            })
            .addCase(fetchRequestForm.rejected, (state) => {
                // остаёмся на значениях по умолчанию — форма не должна ломаться
                state.status = "error";
            })
            .addCase(saveRequestForm.fulfilled, (state, action) => {
                state.settings = { ...DEFAULT_REQUEST_FORM, ...action.payload };
                state.status = "loaded";
            });
    },
});

export const requestFormReducer = requestFormSlice.reducer;
